import JwtBaseClient from './JwtBaseClient';

class NotificationServiceClient extends JwtBaseClient {
  constructor() {
    const headers = {
      'acv-client-version': import.meta.env.VITE_VERSION,
      'acv-client-type': 'desktop',
      'acv-client-os': 'web',
      'acv-client-timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    super(import.meta.env.VITE_NOTIFICATION_SERVICE_URI, null, headers);
  }

  getDeviceToken() {
    return this.get('register/device');
  }

  setDeviceToken(token, previousToken) {
    return this.post('register/device', {
      device_token: token,
      previous_token: previousToken,
    }, null, null, 3);
  }

  deleteDeviceToken(token) {
    return this.delete('register/device', [token]);
  }
}

export default NotificationServiceClient;
